import * as React from 'react'

import { cn } from '@/lib/utils'

type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  children: React.ReactNode
}

export const Label = ({ className, children, ...props }: LabelProps) => (
  <label className={cn('text-sm font-medium', className)} {...props}>
    {children}
  </label>
)
